import { Loader } from '@mantine/core';
import { BaremetalStatus } from '../../../../../../../@types/instance';
import { Avatar } from '../../../../../../../components/Atoms';

const LOADER_COLOR_BY_STATUS: Partial<Record<BaremetalStatus, string>> = {
    installing: 'oklch(65% 0.184 86.047)',
    starting: '#60a5fa',
    rebooting: '#f5b945',
    stopping: '#f59e0b',
    destroying: 'oklch(70.4% 0.191 22.216 / 0.8)',
};

interface BaremetalAvatarProps {
    hostname: string;
    status: BaremetalStatus;
}

export default function BaremetalAvatar({ hostname, status }: BaremetalAvatarProps) {
    const loaderColor = LOADER_COLOR_BY_STATUS[status];

    if (loaderColor) {
        return (
            <div className="w-12 h-12 rounded-md flex justify-center items-center bg-page border-[0.5px] border-line overflow-hidden">
                <Loader type="oval" color={loaderColor} size={30} />
            </div>
        );
    }

    return (
        <div className={status === 'stopped' ? 'opacity-50' : ''}>
            <Avatar value={hostname} size="52" />
        </div>
    );
}
